<style scoped lang="scss">
@import '~variables';

.search {
    position: relative;

    .far {
        position: absolute;
        right: .25em;
        top: calc(50% - .5em);
        font-size: 1.3rem;
        color: $gray-500;
    }
}

</style>

<template>
    <div class="form-group search" v-if="search && search.filters[filterIndex]">
        <input type="search" class="form-control" v-model="search.filters[filterIndex].value" @input="debounceInput" v-bind:placeholder="trans.get('datatable.search')">
        <span class="far fa-times-circle" @click="reset()"></span>
    </div>
</template>

<script>
    let debounce = require('debounce');

    export default {

        props: {
            search: undefined,
            filterIndex: {
                type: Number,
                default: 0
            },
            fields: {
                type: Array,
                default: [
                    {
                        field: 'id',
                        type: 'where'
                    }
                ]
            },
        },

        methods: {

            reset() {
                this.search.resetFilter(this.filterIndex);
                this.search.search();
            },

            debounceInput: debounce(function (e) {
                this.search.page = 1;
                this.search.addFilterFields(this.fields, this.filterIndex);
                this.search.search();
            }, 500),
        }
    }
</script>
